<template>
    <div class="loading-wrapper1">
        <div class="loading1"></div>
    </div>
</template>


<style lang="scss">

.loading-wrapper1 {
    display: flex;
    width: 100%;
    justify-content: center;

    .loading1 {
        display: inline-block;
        width: 10px;
        height: 10px;

        &:after  {
            content: " ";
            display: block;
            width: 14px;
            height: 13px;
            margin-top: 2px;
            margin-right: 10px;
            border-radius: 50%;
            border: 2px solid $button-primary;
            border-color: $button-primary transparent $button-primary transparent;
            animation: loading 1.2s linear infinite;
        }
    }

    @keyframes loading {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
}

</style>
